import { flatMap } from "lodash";
import { forEach } from "lodash";
import React, { useRef } from "react";
import ReactDOM from "react-dom";
export function CellDragHandle(_ref) {
  var thisTable = _ref.thisTable,
      onDragEnd = _ref.onDragEnd,
      cellId = _ref.cellId,
      isSelectionARectangleWithPrimaryInCorner = _ref.isSelectionARectangleWithPrimaryInCorner;
  var xStart = useRef(0);
  var timeoutkey = useRef();
  var rowsToSelect = useRef();
  var rectangleCellPaths = useRef();
  var handleDrag = useRef(function (e) {
    var table = ReactDOM.findDOMNode(thisTable).querySelector(".rt-table");
    var trs = table.querySelectorAll(".rt-tr-group.with-row-data");

    var _cellId$split = cellId.split(":"),
        rowId = _cellId$split[0],
        path = _cellId$split[1];

    var selectedTr = table.querySelector(".rt-tr-group.with-row-data[data-test-id=\"" + rowId + "\"]");
    var selectedIndex = selectedTr.dataset.index;

    if (selectedTr && trs.length) {
      // eslint-disable-next-line no-inner-declarations
      var updateScrollIfNecessary = function updateScrollIfNecessary() {
        var _table$getBoundingCli = table.getBoundingClientRect(),
            y = _table$getBoundingCli.y,
            height = _table$getBoundingCli.height;

        if (cursorY < y) {
          table.scrollBy(0, -5);
        } else if (cursorY > y + height) {
          table.scrollBy(0, 5);
        }
      };

      var selectedY = selectedTr.getBoundingClientRect().y;
      var cursorY = e.clientY;
      clearTimeout(timeoutkey.current);
      updateScrollIfNecessary();
      timeoutkey.current = setInterval(function () {
        updateScrollIfNecessary();
      }, 10);
      var isCursorBelow = cursorY > selectedY;
      rowsToSelect.current = [];
      forEach(trs, function (tr, index) {
        var isSelectedForUpdate;
        var rowId = tr.dataset.testId;

        var changeDashedBorder = function changeDashedBorder(path, on) {
          tr.querySelector("[data-test=\"tgCell_" + path + "\"]").parentNode.classList[on ? "add" : "remove"]("selectedForUpdate");
        };

        if (isCursorBelow ? index > selectedIndex : index < selectedIndex) {
          var _tr$getBoundingClient = tr.getBoundingClientRect(),
              y = _tr$getBoundingClient.y,
              height = _tr$getBoundingClient.height;

          if (isCursorBelow ? y < cursorY : y + height > cursorY) {
            rowsToSelect.current.push(rowId);
            isSelectedForUpdate = true; //add dashed borders

            if (rectangleCellPaths.current) {
              rectangleCellPaths.current.forEach(function (path) {
                changeDashedBorder(path, true);
              });
            } else {
              changeDashedBorder(path, true);
            }
          }
        }

        if (!isSelectedForUpdate) {
          if (rectangleCellPaths.current) {
            rectangleCellPaths.current.forEach(function (path) {
              changeDashedBorder(path, false);
            });
          } else {
            changeDashedBorder(path, false);
          }
        }
      });
    }
  });
  var mouseup = useRef(function () {
    clearTimeout(timeoutkey.current);
    var table = ReactDOM.findDOMNode(thisTable);
    var trs = table.querySelectorAll(".rt-tr-group.with-row-data");

    var _cellId$split2 = cellId.split(":"),
        path = _cellId$split2[1]; //remove the dashed borders


    forEach(trs, function (tr) {
      if (rectangleCellPaths.current) {
        rectangleCellPaths.current.forEach(function (path) {
          var el = tr.querySelector("[data-test=\"tgCell_" + path + "\"]");
          el.parentNode.classList.remove("selectedForUpdate");
        });
      } else {
        var el = tr.querySelector("[data-test=\"tgCell_" + path + "\"]");
        el.parentNode.classList.remove("selectedForUpdate");
      }
    });
    document.removeEventListener("mousemove", handleDrag.current, false);
    document.removeEventListener("mouseup", mouseup.current, false);
    onDragEnd(flatMap(rowsToSelect.current, function (id) {
      if (rectangleCellPaths.current) {
        return rectangleCellPaths.current.map(function (path) {
          return id + ":" + path;
        });
      } else {
        return id + ":" + path;
      }
    }));
  });
  return /*#__PURE__*/React.createElement("div", {
    onMouseDown: function onMouseDown(e) {
      rowsToSelect.current = [];
      xStart.current = e.clientX;
      var isRect = isSelectionARectangleWithPrimaryInCorner();

      if (isRect) {
        rectangleCellPaths.current = isRect.selectedPaths;
      }

      document.addEventListener("mousemove", handleDrag.current, false);
      document.addEventListener("mouseup", mouseup.current, false);
    },
    className: "cellDragHandle"
  });
}